import { createAction, props } from '@ngrx/store';
export const submitCustomizeModal = createAction('[Scatter Plot] Submit Customize Modal', props());
